import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteAcceptedItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackQuoteAcceptedParameters
    extends TrackEventListParameters<"has_notes" | "type", null, TrackQuoteAcceptedItem> {}

const trackQuoteAccepted = (parameters: TrackQuoteAcceptedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "quote_accepted", ...parameters }, options);
};

export default trackQuoteAccepted;
